export class GraphQLErrorHelper {
  private error: any;

  constructor(error: any) {
    this.error = error;
  }

  public isGraphlQLError() {
    return !!this.error.graphQLErrors[0].extensions.response.body.status.message;
  }

  public getBackendErrorMessage() {
    if (this.isGraphlQLError()) {
      return this.error.graphQLErrors[0].extensions.response.body.status.message;
    }
    return null;
  }
}
